import React from 'react';

import DealersBlock from '@/modules/Service/blocks/DealersBlock';
import { useTypedSelector } from '@/store/store';
import {
  getServiceBrands,
  getServiceSingleLanding,
} from '@/store/reducers/service';
import {
  getServiceDealersData,
  getServicePageOptions,
  handleServiceClick,
} from '@/modules/Service/common.helpers';
import { useServiceContext } from '@/modules/Service/common.hooks';

function Dealers() {
  const serviceSingleLanding = useTypedSelector(getServiceSingleLanding);
  const serviceBrands = useTypedSelector(getServiceBrands);
  const { setSelectedDealer } = useServiceContext();

  if (!serviceSingleLanding) {
    return null;
  }

  const { brands, cities } = getServicePageOptions(
    serviceSingleLanding.serviceCenters,
    serviceBrands
  );
  const dealers = getServiceDealersData(serviceSingleLanding.serviceCenters);

  return (
    <DealersBlock
      id={3}
      title="Сервисные центры"
      dealers={dealers.map((dealer) => ({
        ...dealer,
        onClick: (dealer) => handleServiceClick(dealer, setSelectedDealer),
      }))}
      options={{ brands, cities }}
    />
  );
}

export default Dealers;
